module.exports = __webpack_public_path__ + "static/card-relations-requests-2-e5eb2b74960299547067c039751bd8ec.jpg";